import { RectangleStackIcon, UsersIcon, GlobeAltIcon, ShieldCheckIcon, MapPinIcon, ClockIcon, WindowIcon, ClipboardDocumentListIcon, DocumentChartBarIcon, SquaresPlusIcon } from "@heroicons/react/24/outline";

export const FEATURE_CONFIG = {
  workspace_limit: {
    label: "Workspace Limit",
    description: "Total number of workspaces you can create",
    icon: RectangleStackIcon,
    type: "limit",
  },
  user_limit: {
    label: "User Limit",
    description: "Maximum users across the site",
    icon: UsersIcon,
    type: "limit",
  },
  page_limit: {
    label: "Page Limit",
    description: "Maximum number of pages",
    icon: WindowIcon,
    type: "limit",
  },
  form_limit: {
    label: "Form Limit",
    description: "Total forms you can create",
    icon: ClipboardDocumentListIcon,
    type: "limit",
  },
  document_limit: {
    label: "Document Limit",
    description: "Maximum number of uploaded documents",
    icon: DocumentChartBarIcon,
    type: "limit",
  },
  group_limit: {
    label: "Group Limit",
    description: "Maximum number of groups allowed",
    icon: SquaresPlusIcon,
    type: "limit",
  },
  custom_domain_enabled: {
    label: "Enable Custom Domain",
    description: "You can configure custom domain",
    icon: GlobeAltIcon,
    type: "security",
  },
  "2fa_enabled": {
    label: "Two-Factor Authentication",
    description: "Enhanced security with two-factor authentication",
    icon: ShieldCheckIcon,
    type: "security",
  },

  ip_tracking_enabled: {
    label: "IP Tracking",
    description: "Monitor and restrict access by IP address",
    icon: MapPinIcon,
    type: "security",
  },
  auto_logout_enabled: {
    label: "Auto Logout Policy",
    description: "Automatic session timeout for security",
    icon: ClockIcon,
    type: "security",
  },
  // csv_upload_enabled: {
  //   label: "Bulk CSV Upload",
  //   description: "Bulk import data via CSV files",
  //   icon: ArrowUpTrayIcon,
  //   type: "integration",
  // },
  // sso_enabled: {
  //   label: "Single Sign-On (SSO)",
  //   description: "Single sign-on for seamless access",
  //   icon: KeyIcon,
  //   type: "security",
  // },
};

export const formJson = () => {
  const features = Object.keys(FEATURE_CONFIG).map((code) => ({
    code,
    value: FEATURE_CONFIG[code].type === "limit" ? "unlimited" : true,
  }));

  return {
    name: "",
    description: "",
    pricing: {
      type: "standard",
      rates: [
        { interval: "month", amount: 0, discount_percentage: 0 },
        { interval: "year", amount: 0, discount_percentage: 0 },
      ],
    },
    features,
    free_trial: { status: false, days: 0 },
  };
};

export const getFeatureLabel = (code) => FEATURE_CONFIG[code]?.label || code;

export const getFeatureIcon = (code) => FEATURE_CONFIG[code]?.icon;

export const getFeatureDescription = (code, value) => {
  const baseDescription = FEATURE_CONFIG[code]?.description || "";

  if (value === "unlimited") {
    const label = FEATURE_CONFIG[code]?.label || code;
    return `User can add as many ${label.replace(/ Limit$/i, "").toLowerCase()}s as they want.`;
  }

  return baseDescription;
};

export const getFeatureCategory = (code) => FEATURE_CONFIG[code]?.type || "general";

export const getFeatureType = (code) => FEATURE_CONFIG[code]?.type || "general";
